<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'SupplierView',
  mounted() {
    this.$store.state.tabs = [
      {
        'text': this.$t('dashboard'),
        'to': '/supplier'
      }
    ]
  },
}
</script>
